import { Box, Tab, Tabs } from "@mui/material";
import { TitleSection } from "../../components/TitleSection";
import { SyntheticEvent, useState } from "react";
import { styled } from "@mui/material/styles";
import { CustomTabPanel } from "./CustomTabPanel";
import { VerticalSlider } from "../../components/sliderPage/verticalSlider";

interface StyledTabProps {
  label: string;
}

const AntTab = styled((props: StyledTabProps) => <Tab {...props} />)(
  ({ theme }) => ({
    fontWeight: 700,
    borderRadius: "24px",
    backgroundColor: "var(--c-bg-content-color)",
    border: "2px solid var(--c-bg-content-color)",
    boxShadow: "var(--c-box-shadow-btn)",
    margin: "10px 10px 10px 10px",
    transition: "all 0.5s ease",
    "&:hover": {
      backgroundColor: "var(--c-main-color-hover)",
      boxShadow: "var(--c-box-shadow-btn)",
    },
    "&.Mui-selected": {
      backgroundColor: "var(--c-main-color)",
     color: "var(--c-text-color)",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#d1eaff",
    },
  })
);

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const SecSkills = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const arrTab = [
    {
      tab: "Front-end",
      list: [
        {
          label: "HTML",
          icon: "/img/technologies/svg/html-1.svg",
          cover: "/img/technologies/HTML.webp",
          desc: "HTML: The standard markup language for creating web pages, structuring content with elements and tags.",
          value: 99,
        },
        {
          label: "CSS",
          icon: "/img/technologies/svg/css-3.svg",
          cover: "/img/technologies/CSS.webp",
          desc: "CSS: A stylesheet language for describing the presentation of HTML documents, controlling layout, colors, and fonts.",
          value: 99,
        },
        {
          label: "JS",
          icon: "/img/technologies/svg/javascript-1.svg",
          cover: "/img/technologies/JS.png",
          // eslint-disable-next-line no-script-url
          desc: "JavaScript: A dynamic programming language for creating interactive web content and applications.",
          value: 97,
        },
        {
          label: "React",
          icon: "/img/technologies/svg/react-2.svg",
          cover: "/img/technologies/React.png",
          desc: "React: A JavaScript library for building user interfaces with reusable components and efficient state management.",
          value: 95,
        },
        {
          label: "Redux",
          icon: "/img/technologies/svg/redux.svg",
          cover: "/img/technologies/Redux.png",
          desc: "Redux: A state management library for JavaScript applications, enabling predictable state changes and debugging.",
          value: 95,
        },
        {
          label: "Bootstrap",
          icon: "/img/technologies/svg/bootstrap-5-1.svg",
          cover: "/img/technologies/Boostrap.webp",
          desc: "Bootstrap: A front-end framework for developing responsive websites with pre-designed components and a grid system.",
          value: 70,
        },
        {
          label: "Material-UI",
          icon: "/img/technologies/svg/material-ui-1.svg",
          cover: "/img/technologies/Material-UI.webp",
          desc: "Material-UI: A React UI framework implementing Google’s Material Design principles with pre-built components.",
          value: 92,
        },
        {
          label: "React Native",
          icon: "/img/technologies/svg/react-native-1.svg",
          cover: "/img/technologies/React_Native.png",
          desc: "React Native: A framework for building cross-platform mobile applications using React with a single codebase.",
          value: 60,
        },
        {
          label: "TS",
          icon: "/img/technologies/svg/typescript.svg",
          cover: "/img/technologies/TS.webp",
          desc: "TypeScript: A superset of JavaScript that adds static typing for improved code quality and early error detection.",
          value: 90,
        },
        {
          label: "NextJS",
          icon: "/img/technologies/svg/next-js.svg",
          cover: "/img/technologies/next.webp",
          desc: "Next.js: A React framework for server-side rendering and static site generation with routing and API routes.",
          value: 87,
        },
        {
          label: "Redux Toolkit",
          icon: "/img/technologies/svg/redux.svg",
          cover: "/img/technologies/Redux.png",
          desc: "Redux Toolkit: A toolset for efficient Redux development, simplifying store setup and managing state.",
          value: 80,
        },
        {
          label: "jQuery",
          icon: "/img/technologies/svg/jquery-4.svg",
          cover: "/img/technologies/jQuery.webp",
          desc: "jQuery: A lightweight JavaScript library that simplifies DOM manipulation, event handling, and AJAX requests.",
          value: 60,
        },
        {
          label: "Redux Saga",
          icon: "/img/technologies/edit/Redux-Saga.png",
          cover: "/img/technologies/redux-saga.webp",
          desc: "A middleware library for managing side effects in Redux applications, simplifying asynchronous actions and complex flows.",
          value: 82,
        },
        {
          label: "React Testing Library",
          icon: "/img/technologies/edit/React-Testing-Library.png",
          cover: "/img/technologies/testreact.webp",
          desc: "A testing utility for React components that promotes best practices by focusing on user interactions and behavior.",
          value: 81,
        },
        {
          label: "ChartJS",
          icon: "/img/technologies/edit/ChartJS.png",
          cover: "/img/technologies/chart-js.webp",
          desc: "A flexible JavaScript library for creating interactive and visually appealing charts and graphs in web applications.",
          value: 60,
        },
      ],
    },
    {
      tab: "Back-end",
      list: [
        {
          label: "NodeJs",
          icon: "/img/technologies/svg/nodejs-2.svg",
          cover: "/img/technologies/NodeJs.webp",
          desc: "Node.js: A JavaScript runtime built on Chrome's V8 engine, allowing server-side scripting and building scalable applications.",
          value: 36,
        },
        {
          label: "MySQL",
          icon: "/img/technologies/edit/MySQL.png",
          cover: "/img/technologies/MySQL.webp",
          desc: "MySQL: A popular open-source relational database management system that uses SQL for data storage and retrieval.",
          value: 28,
        },
        {
          label: "MongoDB",
          icon: "/img/technologies/svg/mongodb-icon-1.svg",
          cover: "/img/technologies/MongoDB.webp",
          desc: "MongoDB: A NoSQL database that stores data in flexible, JSON-like documents, enabling high scalability and performance.",
          value: 52,
        },
        {
          label: "ExpressJs",
          icon: "/img/technologies/edit/ExpressJs.png",
          cover: "/img/technologies/express.webp",
          desc: "Express.js: A minimal and flexible Node.js web application framework that provides robust features for building web applications.",
          value: 30,
        },
        {
          label: "SQLite",
          icon: "/img/technologies/edit/SQLite.png",
          cover: "/img/technologies/sqlite.webp",
          desc: "SQLite: A self-contained, serverless, and zero-configuration SQL database engine, ideal for embedded applications.",
          value: 29,
        },
        {
          label: "Rest API",
          icon: "/img/technologies/edit/Rest-API.png",
          cover: "/img/technologies/rest.webp",
          desc: "REST API: An architectural style for designing networked applications, using HTTP requests to access and manipulate data.",
          value: 88,
        },
      ],
    },
    {
      tab: "Tools",
      list: [
        {
          label: "Git",
          icon: "/img/technologies/svg/git-icon.svg",
          cover: "/img/technologies/git.webp",
          desc: "Git: A distributed version control system for tracking changes in source code during software development.",
          value: 85,
        },
        {
          label: "Axios",
          icon: "/img/technologies/svg/axios.svg",
          cover: "/img/technologies/axios.webp",
          desc: "Axios: A promise-based HTTP client for the browser and Node.js, used for making API requests and handling responses.",
          value: 90,
        },
        {
          label: "Postman",
          icon: "/img/technologies/svg/postman.svg",
          cover: "/img/technologies/postman.webp",
          desc: "Postman: An API development environment for building, testing, and documenting APIs efficiently.",
          value: 81,
        },
        {
          label: "Figma",
          icon: "/img/technologies/svg/figma-icon.svg",
          cover: "/img/technologies/figma.webp",
          desc: "Figma: A collaborative interface design tool that allows real-time design, prototyping, and feedback.",
          value: 98,
        },
        {
          label: "Blender",
          icon: "/img/technologies/svg/blender-2.svg",
          cover: "/img/technologies/blender.webp",
          desc: "Blender: An open-source 3D creation suite for modeling, animation, simulation, and rendering.",
          value: 92,
        },
        {
          label: "Photoshop",
          icon: "/img/technologies/svg/adobe-photoshop-2.svg",
          cover: "/img/technologies/AP.webp",
          desc: "Photoshop: A powerful image editing software used for creating and manipulating graphics and photos.",
          value: 91,
        },
        {
          label: "After Effects",
          icon: "/img/technologies/svg/after-effects-1.svg",
          cover: "/img/technologies/AE.webp",
          desc: "After Effects: A digital visual effects and motion graphics software for creating stunning animations and compositions.",
          value: 75,
        },
        {
          label: "3D modeling",
          icon: "/img/technologies/edit/3D_modeling.png",
          cover: "/img/technologies/3D.webp",
          desc: "3D modeling: The process of creating three-dimensional representations of objects using specialized software.",
          value: 83,
        },
      ],
    },
  ];

  return (
    <>
      <VerticalSlider />
      <Box
        id={"skills"}
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingX: {
            xs: "15px",
            sm: "50px",
            md: "70px",
          },
          mt: "86px",
        }}
      >
        <Box sx={{ mb: "20px", height: "100%" }}>
          <TitleSection title={"Skills"} value={70} />
        </Box>
        <Box
          sx={{
            width: "100%",
            height: {
              xs: "700px",
              sm: "750px",
              md: "450px",
              lg: "470px",
            },
          }}
        >
          <Box
            sx={{ borderColor: "divider", minHeight: "5px" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              TabIndicatorProps={{
                sx: {
                  height: "0px",
                },
              }}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                width: "100%",
                "& .MuiTabs-flexContainer": {
                  mx: {
                    xs: 3,
                    sm: 0,
                  },
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                },
              }}
            >
              {arrTab?.map((el: any, inx: number) => (
                <AntTab
                  sx={{
                   color: "var(--c-text-color)",
                    minHeight: 1,
                    fontSize: {
                      xs: "8px",
                      md: "11px",
                      lg: "13px",
                    },
                    height: {
                      xs: "35px",
                      sm: "40px",
                    },
                  }}
                  label={el?.tab || ""}
                  {...a11yProps(inx)}
                />
              ))}
            </Tabs>
          </Box>
          {arrTab?.map((el: any, inx: number) => (
            <CustomTabPanel value={value} index={inx} item={el} />
          ))}
        </Box>
      </Box>
    </>
  );
};
